import { useContext, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import BookingServices from "services/BookingServices";
import { notifyError, notifySuccess } from "utils/toast";
import { AdminContext } from "context/AdminContext";
import dayjs from "dayjs";
import OneWayPickupServices from "services/OnewayPickupServices";

const useBookingSubmit = (id) => {
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedStartCity, setSelectedStartCity] = useState(null);
  const [selectedEndCity, setSelectedEndCity] = useState(null);

  const [selectedStartCityName, setSelectedStartCityName] = useState(null);
  const [selectedEndCityName, setSelectedEndCityName] = useState(null);
  const [selectedTripType, setSelectedTripType] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bookingDate, setBookingDate] = useState(null);
  const [itinerary, setItinerary] = useState("");
  const [specialNote, setSpecialNote] = useState("");
  const [vehicleNote, setVehicleNote] = useState("");
  const [arrivalVia, setArrivalVia] = useState("");
  const [departureVia, setDepartureVia] = useState("");
  const [gst, setGst] = useState(false);
  const [addonDetails, setAddonDetails] = useState({});
  const [adultCount, setAdultCount] = useState();
  const [days, setDays] = useState(0);
  const [agentId, setAgentId] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [selectedSeat, setSelectedSeat] = useState("");
  const [pickupTime, setPickupTime] = useState();
  const [hourrentalType, setHourRentaltype] = useState(0);
  const [title, setTitle] = useState("Mr.");
  const [isOnline, setIsOnline] = useState(false);
  const [myData, setMydata] = useState();
  const [selectedMultiValue, setSelectedMultiValue] = useState(false);
  const [selectedOneWayPackage, setSelectedOneWayPackage] = useState(null);
  const [selectedOneWayPackageName, setSelectedOneWayPackageName] =
    useState(null);
  const previousDaysRef = useRef(0);

  const handleChangeMultiTrip = (value) => {
    setSelectedMultiValue(value);
  };
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    watch,
    unregister,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const previousDays = previousDaysRef.current;

    if (days < previousDays) {
      for (let i = days + 1; i <= previousDays; i++) {
        unregister(`day_${i}_start_date`);
        unregister(`day_${i}_startcity`);
        unregister(`day_${i}_endcity`);
      }
    }

    previousDaysRef.current = days;
  }, [days, unregister]);

  const formatPickupTime = (pickupTime) => {
    const date = new Date(pickupTime);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const onSubmit = async (data) => {
    setLoading(true);

    var payload;

    // if (selectedTripType === "Holiday Package" || selectedTripType === "Outstation") {
    //   const no_of_days = data.no_of_days;
    //   const start_date = new Date(data[`day_${1}_start_date`]).toLocaleDateString("en-GB")
    //     .split("/")
    //     .join("-");
    //   const end_date = new Date(data[`day_${no_of_days}_start_date`]).toLocaleDateString("en-GB")
    //     .split("/")
    //     .join("-");

    //   const trip_date = {};
    //   const start_city = {};
    //   const end_city = {};

    //   for (let i = 1; i <= no_of_days; i++) {
    //     const formattedDate = new Date(data[`day_${i}_start_date`])
    //       .toLocaleDateString("en-GB")
    //       .split("/")
    //       .join("-");

    //     trip_date[i] = formattedDate;
    //     start_city[i] = data[`day_${i}_startcity`];
    //     end_city[i] = data[`day_${i}_endcity`];
    //   }

    //   const transformedData = {
    //     no_of_days,
    //     start_date,
    //     end_date,
    //     trip_date,
    //     start_city,
    //     end_city,
    //   };
    //   payload = {
    //     ...transformedData
    //   };
    // }

    if (
      selectedTripType === "Holiday Package" ||
      selectedTripType === "Outstation"
    ) {
      const no_of_days = Number(data.no_of_days);

      const formatDate = (date) => {
        if (!date) return "";

        const parsedDate = new Date(date);

        if (Number.isNaN(parsedDate.getTime())) return "";

        return parsedDate.toLocaleDateString("en-GB").split("/").join("-");
      };

      const trip_date = {};
      const start_city = {};
      const end_city = {};

      for (let i = 1; i <= no_of_days; i++) {
        trip_date[i] = formatDate(data[`day_${i}_start_date`]);
        start_city[i] = data[`day_${i}_startcity`] || "";
        end_city[i] = data[`day_${i}_endcity`] || "";
      }

      payload = {
        no_of_days,
        start_date: formatDate(data.day_1_start_date),
        end_date: formatDate(data[`day_${no_of_days}_start_date`]),
        trip_date,
        start_city,
        end_city,
      };
    }

    delete data.multitrip;
    try {
      if (arrivalVia !== "") {
        data.arrival_via = arrivalVia;
      } else {
        delete data.arrival_via;
      }
      if (departureVia !== "") {
        data.departure_via = departureVia;
      } else {
        delete data.departure_via;
      }

      const offset = bookingDate.getTimezoneOffset() * 60000; // Timezone offset in milliseconds
      const localISODate = new Date(bookingDate.getTime() - offset)
        .toISOString()
        .split("T")[0];

      data.booking_date = localISODate;
      data.is_online = false;
      data.itinerary = itinerary;
      data.title = title;
      data.special_note = specialNote;
      data.vehicle_note = vehicleNote;
      data.hour_rental_type = hourrentalType;
      data.pickup_time = pickupTime ? formatPickupTime(pickupTime) : "";
      data.arrival = Number(selectedStartCity) || selectedStartCity;

      // if (!selectedEndCity) {
      //   data.departure = Number(selectedStartCity) || selectedStartCity;
      // } else {
      //   data.departure = Number(selectedEndCity) || selectedEndCity;
      // }

      if (selectedTripType === "Hour Rental") {
        data.departure = Number(selectedStartCity) || selectedStartCity;
      } else {
        data.departure = Number(selectedEndCity) || selectedEndCity;
      }

      data.is_multi_trip = selectedMultiValue;
      data.add_on = addonDetails;
      data.is_gst = true;
      data.no_of_adult = data.no_of_adult ? data.no_of_adult : 1;
      if (
        selectedTripType === "Hour Rental" ||
        selectedTripType === "Airport Pickup" ||
        selectedTripType === "Airport Drop"
      ) {
        const offset2 = startDate.getTimezoneOffset() * 60000; // Timezone offset in milliseconds
        const localISODate2 = new Date(startDate.getTime() - offset2)
          .toISOString()
          .split("T")[0];

        const offset3 = startDate.getTimezoneOffset() * 60000; // Timezone offset in milliseconds
        const localISODate3 = new Date(startDate.getTime() - offset3)
          .toISOString()
          .split("T")[0];
        data.start_date = localISODate2;
        data.end_date = localISODate3;
        data.no_of_days = 1;

        // data.start_city = {
        //   "1": selectedStartCityName
        // }
        // data.end_city = {
        //   "1": selectedEndCityName ? selectedEndCityName : selectedStartCityName
        // }

        data.start_city = {
          1: String(selectedStartCityName),
        };

        if (id && !selectedEndCity) {
          data.end_city = {
            1: String(selectedStartCityName),
          };
        } else {
          data.end_city = {
            1: String(selectedEndCityName || selectedStartCityName),
          };
        }

        data.trip_date = {
          1: localISODate2,
        };
      }

      if (selectedTripType === "Oneway" && selectedOneWayPackage) {
        data.oneway_package_id = selectedOneWayPackage.value;

        data.arrival = selectedOneWayPackage.fromCityId[0];
        data.departure = selectedOneWayPackage.toCityId[0];

        data.start_city = { 1: selectedOneWayPackage.fromCityName[0] };
        data.end_city = { 1: selectedOneWayPackage.toCityName[0] };

        const offset2 = startDate.getTimezoneOffset() * 60000;
        const localISODate2 = new Date(startDate.getTime() - offset2)
          .toISOString()
          .split("T")[0];

        data.start_date = localISODate2;
        data.end_date = localISODate2;
        data.no_of_days = 1;
        data.trip_date = { 1: localISODate2 };
        data.pickup_time = pickupTime ? formatPickupTime(pickupTime) : "";
      }

      // payload = { ...payload, ...data };
      // Object.keys(payload).forEach((key) => {
      //   if (/^day_\d+_/.test(key)) {
      //     delete payload[key];
      //   }
      // });

      const isMultiDayTrip =
        selectedTripType === "Holiday Package" ||
        selectedTripType === "Outstation";

      const generatedPayload = payload || {};

      payload = {
        ...data,
        ...(isMultiDayTrip ? generatedPayload : {}),
      };

      // Remove dynamic React Hook Form fields from the API payload
      Object.keys(payload).forEach((key) => {
        if (/^day_\d+_/.test(key)) {
          delete payload[key];
        }
      });

      // Ensure multi-day objects contain only the selected number of days
      if (isMultiDayTrip) {
        const noOfDays = Number(payload.no_of_days);

        const filterDays = (daysObject) =>
          Object.fromEntries(
            Object.entries(daysObject || {}).filter(
              ([day]) => Number(day) >= 1 && Number(day) <= noOfDays,
            ),
          );

        payload.trip_date = filterDays(payload.trip_date);
        payload.start_city = filterDays(payload.start_city);
        payload.end_city = filterDays(payload.end_city);
      }

      setIsSubmitting(true);

      if (id) {
        const res = await BookingServices.updateBookings(
          adminInfo.id,
          id,
          payload,
        );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        if (res.warning) {
          notifyError(res.warning);
        }
        closeDrawer();
      } else {
        const res = await BookingServices.addBookings(adminInfo.id, payload);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        if (res.status === true) {
          closeDrawer();
        }
      }
    } catch (err) {
      notifyError("Something went wrong");
      setIsSubmitting(false);
      // closeDrawer();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const res = await BookingServices.getBookingsById(adminInfo.id, id);
          if (res) {
            var Response = res.data[0];
            setSelectedTripType(Response.package_type);
            setAdultCount(Response.no_of_adult);
            setTitle(Response.title);
            setIsOnline(Response.is_online);
            setValue("agent_id", Response.agent_id);
            setValue("package_type", Response.package_type);
            setValue("client_name", Response.client_name);
            setValue("no_of_days", Response.no_of_days);
            setDays(Response.no_of_days);
            setMydata(Response);
            setValue("selling_price", Response.selling_price);
            setValue("no_of_adult", Response.no_of_adult);
            setValue("no_of_kids", Response.no_of_kids);
            setValue("contact_no", Response.contact_no);
            setValue("al_contact_no", Response.al_contact_no);
            setValue("arrival_details", Response.arrival_details);
            setValue("departure_details", Response.departure_details);
            setValue("vehicle_type", Response.vehicle_type);
            setValue("vehicle_modal", Response.vehicle_modal);
            setValue("arrival_via", Response.arrival_via);
            setValue("departure_via", Response.departure_via);
            setValue("agentref", Response.agentref);
            setSelectedMultiValue(Response.is_multi_trip);
            setVehicleModel(Response.vehicle_modal);
            setVehicleType(Response.vehicle_type);
            setAgentId(Response.agent_id);
            setTitle(Response.title);
            setAddonDetails(Response.add_on !== null ? Response.add_on : {});
            setArrivalVia(Response.arrival_via);
            setDepartureVia(Response.departure_via);
            setItinerary(Response.itinerary);
            setValue("trip_date", Response.travel_date);

            // setSelectedEndCity(Response.departure);
            // setSelectedStartCity(Response.arrival);
            // setSelectedStartCityName(Response.arrival);
            // setSelectedEndCityName(Response.departure);

            // IDs (for dropdowns)
            setSelectedStartCity(Response.arrival);
            setSelectedEndCity(Response.departure);

            // Names (for payload)
            setSelectedStartCityName(Response.start_city?.["1"] || "");
            setSelectedEndCityName(
              Response.end_city?.[Response.no_of_days] || "",
            );

            // onewaypackage list
            if (Response.package_type === "Oneway") {
              const packageRes =
                await OneWayPickupServices.getAllOnewayPickupBasicRate();

              const startCityName = Response.start_city?.["1"];
              const endCityName = Response.end_city?.["1"];

              const matchedPackage = packageRes.data.find(
                (pkg) =>
                  pkg.from_city_name?.[0] === startCityName &&
                  pkg.to_city_name?.[0] === endCityName,
              );

              if (matchedPackage) {
                const selectedPkg = {
                  value: String(matchedPackage.id),
                  label: `${matchedPackage.from_city_name[0]} - ${matchedPackage.to_city_name[0]}`,

                  fromCityId: matchedPackage.from_city,
                  toCityId: matchedPackage.to_city,

                  fromCityName: matchedPackage.from_city_name,
                  toCityName: matchedPackage.to_city_name,

                  vehicle_type_ids: matchedPackage.vehicle_type_id,
                  vehicle_type_names: matchedPackage.vehicle_type_names,
                  min_rate: matchedPackage.min_rate,
                };

                setSelectedOneWayPackage(selectedPkg);

                // restore vehicle type
                setVehicleType(Response.vehicle_type);
                setValue("vehicle_type", Response.vehicle_type);
              }
            }

            if (Response.arrival_time) {
              const parsedTime = dayjs(Response.arrival_time, "h:mm A");
              setPickupTime(parsedTime.isValid() ? parsedTime : null);
              setValue("pickup_time", Response.arrival_time);
            }
            setValue(`day_${1}_startcity`, Response.arrival);
            setSpecialNote(Response.special_note);
            setVehicleNote(Response.vehicle_note);
            setBookingDate(new Date(Response.booking_date));
            const [day, month, year] = Response.start_date.split("-");
            setStartDate(new Date(`${year}-${month}-${day}`));
            const [eday, emonth, eyear] = Response.end_date.split("-");
            setEndDate(new Date(`${eyear}-${emonth}-${eday}`));

            const parseDate = (dateStr) => {
              const [day, month, year] = dateStr.split("-");
              return new Date(`${year}-${month}-${day}`);
            };
            Object.keys(Response.travel_date).forEach((day) => {
              const dateStr = Response.travel_date[day];
              const parsedDate = parseDate(dateStr);
              setValue(`day_${day}_start_date`, parsedDate);
            });

            Object.keys(Response.start_city).forEach((day) => {
              setValue(`day_${day}_startcity`, Response.start_city[day]);
            });

            Object.keys(Response.end_city).forEach((day) => {
              setValue(`day_${day}_endcity`, Response.end_city[day]);
            });
          }
        } catch (err) {
          notifyError("Something went wrong");
        }
      })();
    }
    if (!isDrawerOpen) {
      setTimeout(() => {
        setAdultCount(1);
        setSelectedTripType("");
        setValue("vehicle_type");
        setValue("package_type");
        setValue("contact_no");
        setValue("agent_id");
        setValue("al_contact_no");
        setValue("selling_price");
        setValue("no_of_days");
        setValue("client_name");
        setValue("no_of_adult");
        setValue("no_of_kids");
        setValue("arrival_details");
        setValue("departure_details");
        setValue("arrival_via");
        setValue("departure_via");
        setValue("agentref");
        for (let i = 1; i <= days; i++) {
          setValue(`day_${i}_start_date`);
          setValue(`day_${i}_startcity`);
          setValue(`day_${i}_endcity`);
        }
        setIsOnline(false);
        setMydata();
        setDays(0);
        setSelectedEndCity("");
        setSelectedStartCity("");
        setSelectedStartCityName("");
        setSelectedEndCityName("");
        setStartDate(null);
        setEndDate(null);
        setBookingDate(null);
        setArrivalVia("");
        setDepartureVia("");
        setItinerary("");
        setSpecialNote("");
        setVehicleNote("");
        setVehicleModel("");
        setVehicleType("");
        setAddonDetails({});
        setPickupTime();
        setSelectedSeat("");
        setAgentId("");
        setSelectedOneWayPackage(null);
        setSelectedOneWayPackageName(null);
        setValue("oneway_package", null);
        setValue("vehicle_type", "");
      }, 200);

      clearErrors();

      return;
    }
    // eslint-disable-next-line
  }, [id, isDrawerOpen, setValue, clearErrors]);

  // useEffect(() => {
  //   if (
  //     selectedTripType === "Hour Rental" &&
  //     selectedStartCity
  //   ) {
  //     setSelectedEndCity(selectedStartCity);
  //     setSelectedEndCityName(selectedStartCityName);
  //     setValue("day_1_endcity", selectedStartCity);
  //   }
  // }, [selectedStartCity, selectedStartCityName, selectedTripType, setValue]);

  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    setSelectedStartCity,
    setSelectedEndCity,
    isSubmitting,
    selectedStartCity,
    selectedEndCity,
    startDate,
    endDate,
    setEndDate,
    setStartDate,
    setSelectedTripType,
    selectedTripType,
    bookingDate,
    setBookingDate,
    setItinerary,
    itinerary,
    arrivalVia,
    setArrivalVia,
    departureVia,
    setDepartureVia,
    setSpecialNote,
    specialNote,
    gst,
    setGst,
    vehicleNote,
    setVehicleNote,
    setLoading,
    loading,
    watch,
    setValue,
    addonDetails,
    setAddonDetails,
    setSelectedStartCityName,
    setSelectedEndCityName,
    selectedEndCityName,
    selectedStartCityName,
    days,
    setDays,
    agentId,
    setAgentId,
    vehicleModel,
    vehicleType,
    setVehicleModel,
    setSelectedSeat,
    selectedSeat,
    setVehicleType,
    pickupTime,
    setPickupTime,
    setHourRentaltype,
    hourrentalType,
    isOnline,
    myData,
    title,
    setTitle,
    selectedMultiValue,
    handleChangeMultiTrip,

    setAdultCount,
    adultCount,
    selectedOneWayPackage,
    setSelectedOneWayPackage,
    selectedOneWayPackageName,
    setSelectedOneWayPackageName,
  };
};

export default useBookingSubmit;
